var AWS = require('aws-sdk');

const config = {
    region: 'us-east-1',
    accessKeyId: 'AKIA5HXFVFNNGDIEUIPJ',
    secretAccessKey: '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',
    apiVersion: 'latest'
}

var s3 = new AWS.S3(config);

export class StoreS3 {

    static async list_files(dir = '') {

        if (dir.length && dir[dir.length - 1] !== '/') {
            dir += '/';
        }
        const params = {
            Bucket: "mikehallstudio",
            Prefix: dir,
            Delimiter: "/",
        };
        return new Promise((resolve, reject) => {
            s3.listObjects(params, function (err, data) {
                if (err) {
                    reject(err);
                } else {
                    resolve(data);
                }
            });
        })
    }

    static async get_file(name) {
        const params = {
            Bucket: "mikehallstudio",
            Key: "midi-play/" + name,
        };
        return new Promise((resolve, reject) => {
            s3.getObject(params, (err, data) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(data);
                }
            })
        })
    }

}

export default StoreS3;